import styled from 'styled-components';

export const StyledButtonAction = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin: 0;
`;
